import { Box, Button, Typography } from '@mui/material';

import { AuthChannel } from '../../pages/LoginPage/AuthChannel';

interface IProps {
  questions: Record<string, string>;
  goContinueGuestAuth: (channel: AuthChannel) => void;
  cancel: () => void;
  setChannel: (channel: AuthChannel) => void;
}

export default function MFARequestForm(props: IProps) {
  const { questions, goContinueGuestAuth, cancel, setChannel } = props;

  const goNext = (channel: AuthChannel) => {
    setChannel(channel);
    goContinueGuestAuth(channel);
  };

  const PhoneMFA = () => {
    return (
      <>
        <Typography
          sx={{ margin: (theme) => theme.spacing(2) }}
          variant='body1'>
          {questions['CHANNEL_0']}
        </Typography>
        <Box
          id='PhoneMFA'
          sx={{
            width: '100%',
            gap: '40px',
            display: 'flex',
            justifyContent: 'center',
            margin: (theme) => theme.spacing(2),
          }}>
          <Button
            onClick={() => goNext(AuthChannel.Text)}
            variant='contained'
            color='primary'>
            Text me
          </Button>
          <Button
            onClick={() => goNext(AuthChannel.Voice)}
            variant='contained'
            color='primary'>
            Call Me
          </Button>
        </Box>
      </>
    );
  };

  const EmailMFA = () => {
    return (
      <Box
        id='EmailMFA'
        sx={{
          gap: '10px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          margin: (theme) => theme.spacing(2),
        }}>
        <Typography
          sx={{ margin: (theme) => theme.spacing(2) }}
          variant='body1'>
          {questions['CHANNEL_1']}
        </Typography>
        <Button
          onClick={() => goNext(AuthChannel.Email)}
          variant='contained'
          color='primary'>
          Email Me
        </Button>
      </Box>
    );
  };

  const Divider = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          padding: '10px 0px',
        }}>
        <Box
          sx={{
            height: '1px',
            background: 'grey',
            width: '40px',
            marginRight: '10px',
          }}
        />
        <Typography variant='body1'>OR</Typography>
        <Box
          sx={{
            height: '1px',
            background: 'grey',
            width: '40px',
            marginLeft: '10px',
          }}
        />
      </Box>
    );
  };

  const BuildComponent = () => {
    if (Object.keys(questions).length == 1) {
      if ('CHANNEL_0' in questions && questions['CHANNEL_0'].includes('@')) {
        return (
          <>
            {EmailMFA()}
            {Divider()}
          </>
        );
      } else {
        return (
          <>
            {PhoneMFA()}
            {Divider()}
          </>
        );
      }
    } else {
      return (
        <>
          {PhoneMFA()}
          {Divider()}
          {EmailMFA()}
          {Divider()}
        </>
      );
    }
  };

  return (
    <>
      {BuildComponent()}
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          paddingBottom: '20px',
        }}>
        <Button
          onClick={cancel}
          variant='outlined'
          size='medium'
          color='primary'>
          CANCEL
        </Button>
      </Box>
    </>
  );
}
